const locations = {
    quoteOrderSingle: '/crm/opportunities/quotes/single',
    sellOrderSingle: '/sells/billing/sellOrders/single',
    sellInvoiceSingle: '/sells/billing/sellInvoices/single',
    sellInvoices: '/sells/billing/sellInvoices',
    sellInvoiceMulti: '/sells/billing/sellInvoices/customersDeliveryNotes',
    sellInvoiceRefundSingle: '/sells/billing/sellInvoicesRefund/single',
    sellInvoiceRefundMulti: '/sells/billing/sellInvoicesRefund/customersSellInvoice',
    sellDeliveryNoteMulti: '/sells/billing/sellDeliveryNotes/customersOrders',
    sellDeliveryNoteSingle: '/sells/billing/sellDeliveryNotes/single',
    sellDeliveryNoteRefundSingle: '/sells/billing/sellDeliveryNotesRefund/single',
    sellDeliveryNoteRefundMulti: '/sells/billing/sellDeliveryNotesRefund/customersSellDeliveryNote',
    sellTicketSingle: '/sells/pointOfSale/sellTickets/single',
    tpv: '/sells/pointOfSale/tpv',
    buyOrderSingle: '/buys/buys/orders/single',
    buyDeliveryNoteSingle: '/buys/buys/deliveryNotes/single',
    buyInvoiceSingle: '/buys/buys/invoices/single',
    customerProjectsStatusFlow: '/sat/projects/projectStatusFlow',
    customerOppStatusFlow: '/crm/opportunities/opportunitiesStatusFlow',
    allCustomers: '/crm/contacts/allCustomers',
    customerB2B: '/crm/contacts/customersB2B',
    customerB2C: '/crm/contacts/customers',
    customerMaterialStock: '/logistic/buys/stockMaterials/single',
    customerMaterialStockRefund: '/logistic/buys/stockMaterialsRefund/single',
    customerMaterialStockRefundCreate: '/logistic/buys/stockMaterialsRefund/createRefundCustomerMaterialStock',
    quoteListing: '/crm/opportunities/quotes',
    buyListing: '/buys/buys/orders',
    addon: '/catalog/product/addon',
    escandalling: '/catalog/product/escandalling',
    material: '/catalog/product/materials',
    packaging: '/catalog/product/packaging',
    product: '/catalog/product/products',
    services: '/catalog/product/services',
    customer: '/crm/contacts',
    staffTimeControlWC: '/config/humanResources/workingCalendars',
    task: '/sat/task/tasks',
    myTask: '/sat/task/myTask',
    tasksMain: '/sat/task/tasks/main',
    customerCampaigns: '/crm/opportunities/campaigns',
    customerProjects: '/sat/projects/customerProjects',
    customerOpportunities: '/crm/opportunities/customerOpportunities',
    customerProjectTypes: '/config/customers/projectTypes',
    tasksCustomFields: '/config/tasks/customFields',
    shippingZones: '/config/logistic/shippingZones',
    shippingCompanies: '/config/logistic/shippingCompanies',
    company: '/company',
    projectTypesMain: '/config/customers/projectTypes/main',
    customFieldsMain: '/config/tasks/customFields/main',
    employees: '/humanResources/bases/employees',
    employeeParameters: '/employeeProfile/parameters',
    timeControlCEWM: '/humanResources/timeControl/controlEmployeesWorkingMonth',
    categories: '/config/products/categories/1',
    features: '/config/products/features/main',
    priceZones: '/config/products/priceZones/main',
    variants: '/config/products/variants/main',
    categoriesAddons: '/config/products/categoriesAddons/1',
    categoriesMaterial: '/config/products/categoriesMaterial/1',
    parameters: '/config/app/parameters/main',
    parametersCustomer: '/config/customers/groups',
    shippingZonesMain: '/config/logistic/shippingZones/main',
    shippingCompaniesMain: '/config/logistic/shippingCompanies/main',
    config: '/config',
    configApp: '/config/app',
    configCustomers: '/config/customers',
    configProducts: '/config/products',
    configTasks: '/config/tasks',
    configLogistic: '/config/logistic',
    configHumanResources: '/config/humanResources',
    configBillingGroups: '/config/logistic/billingGroups',
    configBillingTypeBuy: '/config/logistic/billingGroups/billingTypeBuy',
    configBillingTypeSell: '/config/logistic/billingGroups/billingTypeSell',
    suppliers: '/buys/buys/suppliers',
    sharedQuote: 'https://presupuestos.teinor.net/es',
    workSheets: '/sells/billing/workSheets',
    workSheetSingle: '/sells/billing/workSheets/single',
    workSheetGroupStatus: '/config/logistic/workSheetGroupStatus',
    workSheetGroupStatusMain: '/config/logistic/workSheetGroupStatus/main',
    remittances: '/finances/treasury/payments/remittances',
    manufacturingSingle: '/catalog/product/manufacturing/single',
    adjustmentDeliveryNoteSingle: '/catalog/product/adjustmentDeliveryNotes/single',
    manufacturingGroupStatus: '/config/logistic/manufacturingGroupStatus',
    manufacturingGroupStatusMain: '/config/logistic/manufacturingGroupStatus/main',
}

export default locations